module.exports = function() {
  return new Worker(__webpack_public_path__ + "3f55cf9a7f9f7f7bdc5c.worker.js");
};


// WEBPACK FOOTER //
// ./app/frontend/workers/pages.worker.js